import { PermissionActions } from '@/features/permissions/permissionActions.js'
import SuperAdminDummyRouter from '@/features/superAdmin/SuperAdminDummyRouter.vue'

export const personTypeManagementRoutes = [
  {
    path: 'person-type-management',
    component: SuperAdminDummyRouter,
    meta: { permissionAction: PermissionActions.PersonTypesView },
    children: [
      {
        path: '',
        component: () =>
          import('@/features/settingsManagement/personTypeManagement/list/PersonTypeListView.vue'),
        meta: { permissionAction: PermissionActions.PersonTypesView },
      },
      {
        path: ':personTypeId',
        component: () =>
          import('@/features/settingsManagement/personTypeManagement/edit/PersonTypeEditView.vue'),
        meta: { permissionAction: PermissionActions.PersonTypesView },
      },
      {
        path: 'new',
        component: () =>
          import('@/features/settingsManagement/personTypeManagement/edit/PersonTypeEditView.vue'),
        meta: { permissionAction: PermissionActions.PersonTypesCreate },
      },
    ],
  },
]
